import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMemo } from 'react';
import { DYNAMIC_STEPS_CONFIG } from '../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJBackIcon from '../../../../assets/svg/back-arrow.svg?react';
import FJDynamicStepFormRendererContainer from '../container/FJDynamicStepFormRendererContainer';
import FJCategorySelectorContainer from '../container/FJCategorySelectorContainer';
import FJHeadshotContinueButtonContainer from '../container/FJHeadshotContinueButtonContainer';

import styles from './FJHeadshotGeneratorStepper.module.less';

const FJHeadshotGeneratorStepper = ({ currentStepIndex, onPrevious, selectedCategory, active }) => {
    // 根据选择的分类动态获取步骤
    const steps = useMemo(() => DYNAMIC_STEPS_CONFIG[selectedCategory] || [], [selectedCategory]);
    const isShowProgressIndicator = useMemo(
        () => currentStepIndex > 0 && currentStepIndex < steps.length - 2,
        [currentStepIndex, steps],
    );
    const isFirstStep = useMemo(() => currentStepIndex === 0, [currentStepIndex]);

    return (
        <div className={styles.stepper_container} style={{ display: active ? 'flex' : 'none' }}>
            <div className={classNames(styles.stepper, { [styles.linear_bg]: isFirstStep })} id='stepper'>
                {/* 进度指示器, 第一项不显示 */}
                {!isFirstStep && (
                    <div className={styles.progressIndicator}>
                        <div className={styles.back_button} onClick={onPrevious}>
                            <FJBackIcon className={styles.back_icon} />
                            {FJLocalStore._('back')}
                        </div>
                        <div className={styles.progress_mask}>
                            {steps.map((step, index) => (
                                <div
                                    key={index}
                                    style={{
                                        visibility: isShowProgressIndicator ? 'visible' : 'hidden',
                                        display: index === 0 || index === steps.length - 1 ? 'none' : 'block',
                                        ['--progress-index']: index - 1,
                                        ['--count']: steps.length - 2,
                                    }}
                                    className={`${styles.progressStep} ${index === currentStepIndex ? styles.active : ''} ${index < currentStepIndex ? styles.completed : ''}`}
                                ></div>
                            ))}
                        </div>
                    </div>
                )}

                {/* 当前步骤的表单内容 */}
                <div className={styles.stepContent}>
                    <FJVerticalScroller className={styles.scroller} id='headshot_stepper_scroller'>
                        {currentStepIndex === 0 ? (
                            <FJCategorySelectorContainer />
                        ) : (
                            <FJDynamicStepFormRendererContainer
                                currentStepIndex={currentStepIndex}
                                selectedCategory={selectedCategory}
                            />
                        )}
                    </FJVerticalScroller>
                </div>
            </div>
            {/* 选择步骤按钮 */}
            <FJHeadshotContinueButtonContainer />
        </div>
    );
};

FJHeadshotGeneratorStepper.propTypes = {
    currentStepIndex: PropTypes.number,
    onPrevious: PropTypes.func,
    selectedCategory: PropTypes.string,
    active: PropTypes.bool,
};

export default FJHeadshotGeneratorStepper;
